import styled from 'styled-components';

export const Container = styled.div`
    position: fixed;
    bottom: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    z-index: 999;

    @media (min-width: 1500px) {
        bottom: 20px;
        right: 180px;
    }
`;